import type { LanguageProficiency } from '@seek/ca-myprofile-utils';

import type { FormValues } from './LanguageForm';
import type { LanguageUpdate } from './types';

export const initialValues: FormValues = {
  language: {
    text: '',
  },
};

export const getInitialState = (language?: LanguageProficiency): FormValues => {
  if (!language) {
    return initialValues;
  }

  return {
    ...initialValues,
    language: {
      text: language.name.text,
      ontologyId: language.name.ontologyId ?? undefined,
    },
  };
};

export const languageFormUpdateToLanguageUpdate = (
  languageUpdate: FormValues,
): LanguageUpdate => ({
  name: {
    text: languageUpdate.language.text,
    ontologyId: languageUpdate.language.ontologyId ?? null,
  },
});

export const getStructuredData = (thing: { value: string }) => ({
  ontologyId: thing.value,
});
